import "./CreditHistoryPage.css";

import React, { useEffect, useState } from "react";
import { getTranscationActivityApi, renderOrganizations } from "Config/API/get";

import ApiLoader from "Components/Loader/ApiLoader";
import CompanyLogo from "Media/blank-profile-picture.png";
import DownArrow from "Media/icons/Iconly-Bold-Tick-Square.svg";
import Headers from "Components/Header/Headers";
import Navigation from "Components/SideNavBar/Navigation";
import SearchIcon from "@mui/icons-material/Search";
import UpArrow from "Media/icons/Iconly-Bold-Tick-Up-Square.svg";
import useFullPageLoader from "Hooks/useFullPageLoader";
import { useSelector } from "react-redux";

const COMMENT_PADDING_LEFT_COLUMN = { width: "60%", paddingLeft: "10px" };
const COMMENT_WIDTH_RIGHT_COLUMN = { width: "60%" };

// One organization card with its expandable transaction history.
// The left column adds extra padding to the comment cell and a space after "Current Balance:".
const OrganizationCard = ({
  organization,
  isActive,
  loading,
  transcationList,
  isLeftColumn,
  onToggle,
}) => {
  const commentStyle = isLeftColumn
    ? COMMENT_PADDING_LEFT_COLUMN
    : COMMENT_WIDTH_RIGHT_COLUMN;

  return (
    <div className="credit-history-transcation-card">
      <div className="credit-history-transcation-card-wrapper">
        <div className="credit-history-transcation-card-logo">
          <img src={organization?.logo || CompanyLogo} alt="Logo" />
        </div>
        <div className="credit-history-transcation-card-content">
          <h5>{organization?.organization_name || "None"}</h5>
          <span>
            Current Balance:{isLeftColumn && " "}
            <b>{organization?.credit || "00"}</b>
          </span>
        </div>
        <div
          className="credit-history-transcation-card-button"
          onClick={() => onToggle(organization)}
        >
          {isActive ? (
            <span>
              Hide <img src={UpArrow} alt="arrow-icon" />
            </span>
          ) : (
            <span>
              View History
              <img src={DownArrow} alt="arrow-icon" />
            </span>
          )}
        </div>
      </div>
      {isActive && (
        <div
          className="credit-history-transcation-card-expanded"
          style={{ boxShadow: "0px 3px 6px #00000029" }}
        >
          <div className="credit-history-transcation-card-expanded-head-row">
            <div style={{ width: "20%" }}>DATE</div>
            <div style={commentStyle}>COMMENT</div>
            <div style={{ width: "20%" }}>CREDITS</div>
          </div>
          <div style={{ height: "94px", overflowY: "scroll" }}>
            {!loading ? (
              transcationList?.length > 0 ? (
                transcationList.map((transaction) => (
                  <div
                    className="credit-history-transcation-card-expanded-body-row"
                    key={transaction?.transactionId}
                  >
                    <div style={{ width: "20%" }}>
                      {transaction?.dateTime || "-"}
                    </div>
                    <div style={commentStyle}>
                      {transaction?.description || "-"}
                    </div>
                    <div style={{ width: "20%" }}>
                      <b>{transaction?.credit || "-"}</b>
                    </div>
                  </div>
                ))
              ) : (
                <div style={{ textAlign: "center" }}>No History Found</div>
              )
            ) : (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "100%",
                }}
              >
                <ApiLoader
                  height="35px"
                  width="35px"
                  borderWidth="7px"
                  borderTopWidth="7px"
                />
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

const DONE_TYPING_INTERVAL = 1500;

const CreditHistoryPage = () => {
  let typingTimer;
  const token = localStorage.getItem("token");
  const [loader, setLoader, resetLoader] = useFullPageLoader();
  const [leftSideOrganizationList, setLeftSideOrganizationList] = useState([]);
  const [rightSideOrganizationList, setRightSideOrganizationList] = useState(
    []
  );
  const [transcationList, setTranscationList] = useState([]);
  const [activeTab, setActiveTab] = useState("");
  const [loading, setLoading] = useState(false);
  const creditTotal = useSelector(
    (state) => state.getStripeCreditTotalBalanceReducer
  );

  useEffect(() => {
    getAllOrganizations();
    // eslint-disable-next-line
  }, []);

  const divideListOfOrganizations = (value) => {
    setLeftSideOrganizationList(value?.filter((_, index) => index % 2 === 0));
    setRightSideOrganizationList(value?.filter((_, index) => index % 2 !== 0));
  };

  const search_fuction = (value) => {
    const transcation_status = renderOrganizations(token, value);
    transcation_status.then((res) => {
      divideListOfOrganizations(res?.listOfOrganisation);
    });
  };

  const getAllOrganizations = () => {
    setLoader();
    const organizationListApi = renderOrganizations(token, "");
    organizationListApi.then((res) => {
      resetLoader();
      divideListOfOrganizations(res?.listOfOrganisation);
    });
  };

  const getOrganizationData = (data) => {
    setTranscationList([]);
    if (activeTab === data?.id) {
      setActiveTab("");
    } else {
      setLoading(true);
      setActiveTab(data?.id || "");
      const transactionStatus = getTranscationActivityApi(token, data?.id);
      transactionStatus.then((res) => {
        setLoading(false);
        if (res?.status === 200) {
          setTranscationList(res?.data?.data?.result);
        }
      });
    }
  };

  return (
    <>
      <div className="credit-history-transcation-main">
        <div className="credit-history-transcation-main-header">
          <Headers />
        </div>
        <div className="credit-history-transcation-navigation">
          <Navigation />
        </div>
        <div className="credit-history-transcation-wrapper">
          <div className="credit-history-transcation-header">
            Balance History
          </div>
          <div className="credit-history-transcation-content">
            <div className="credit-history-transcation-top-part">
              <div className="credit-history-transcation-search">
                <input
                  type="search"
                  placeholder="Search..."
                  onChange={(e) => {
                    clearTimeout(typingTimer);
                    if (e.target.value || e.target.value === "") {
                      typingTimer = setTimeout(() => {
                        search_fuction(e.target.value);
                      }, DONE_TYPING_INTERVAL);
                    }
                  }}
                />
                <SearchIcon />
              </div>
              <div className="credit-history-transcation-balance">
                <span>TOTAL BALANCE </span>
                <b>{Number(creditTotal || 0).toFixed(2)}</b>
              </div>
            </div>
            <div className="credit-history-transcation-bottom-part">
              {[
                {
                  className: "credit-history-transcation-bottom-left-side",
                  list: leftSideOrganizationList,
                  isLeftColumn: true,
                },
                {
                  className: "credit-history-transcation-bottom-right-side",
                  list: rightSideOrganizationList,
                  isLeftColumn: false,
                },
              ].map(({ className, list, isLeftColumn }) => (
                <div key={className} className={className}>
                  {list?.length > 0
                    ? list.map((organization) => (
                        <OrganizationCard
                          key={organization?.id}
                          organization={organization}
                          isActive={activeTab === organization?.id}
                          loading={loading}
                          transcationList={transcationList}
                          isLeftColumn={isLeftColumn}
                          onToggle={getOrganizationData}
                        />
                      ))
                    : null}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      {loader}
    </>
  );
};

export default CreditHistoryPage;
